import { render, staticRenderFns } from "./EmbeddedUploadProfileImage.vue?vue&type=template&id=227a842c"
import script from "./EmbeddedUploadProfileImage.vue?vue&type=script&lang=js"
export * from "./EmbeddedUploadProfileImage.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedUploadProfileImage.vue?vue&type=style&index=0&id=227a842c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports